const routes = [
    {
        path: "/prep/modules",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "prepmodule_index"
        }
    }
];

export default routes;
